var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs0, _defs1, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49, _defs50, _defs51, _defs52, _defs53, _defs54, _defs55, _defs56, _defs57, _defs58, _defs59, _defs60, _defs61, _defs62;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 351.3 190.6",
    style: {
      enableBackground: "new 0 0 351.3 190.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000181072880637853343610000008482177749383138235_);fill:#3C3C3B;}\r\n\t.st1{clip-path:url(#SVGID_00000150091354658165519060000001133267038585928341_);fill:#3C3C3B;}\r\n\t.st2{clip-path:url(#SVGID_00000168816309712831775410000010410460988108334241_);fill:#3C3C3B;}\r\n\t.st3{clip-path:url(#SVGID_00000121253765729697879820000003142777755616324496_);fill:#3C3C3B;}\r\n\t.st4{clip-path:url(#SVGID_00000101089621754154061090000013617541024570728857_);fill:#3C3C3B;}\r\n\t.st5{clip-path:url(#SVGID_00000108992843054115540530000016075578708518845855_);fill:#3C3C3B;}\r\n\t.st6{clip-path:url(#SVGID_00000088819634398610218960000013475020742175290246_);fill:#3C3C3B;}\r\n\t.st7{clip-path:url(#SVGID_00000161606739485557891470000013137290238503838350_);fill:#3C3C3B;}\r\n\t.st8{clip-path:url(#SVGID_00000078745772187819044470000009807040004079348608_);fill:#3C3C3B;}\r\n\t.st9{clip-path:url(#SVGID_00000006685920568216742900000011848078028457613193_);fill:#3C3C3B;}\r\n\t.st10{clip-path:url(#SVGID_00000082333719261983226240000011526033199322134144_);fill:#3C3C3B;}\r\n\t.st11{clip-path:url(#SVGID_00000110447036980537568630000000251476114145024137_);fill:#3C3C3B;}\r\n\t.st12{clip-path:url(#SVGID_00000088851680037395067370000010869041038271237286_);fill:#3C3C3B;}\r\n\t.st13{clip-path:url(#SVGID_00000122695348699855315660000017162730021013523845_);fill:#3C3C3B;}\r\n\t.st14{clip-path:url(#SVGID_00000057143224020923791270000001202002435794189500_);fill:#3C3C3B;}\r\n\t.st15{clip-path:url(#SVGID_00000012471396175823001100000016475729129500357001_);fill:#3C3C3B;}\r\n\t.st16{clip-path:url(#SVGID_00000024712368947631558070000013389988380212854941_);fill:#3C3C3B;}\r\n\t.st17{clip-path:url(#SVGID_00000060709897672080066590000008184598383274912929_);fill:#3C3C3B;}\r\n\t.st18{clip-path:url(#SVGID_00000137108837232802055470000009515548503026955702_);fill:#3C3C3B;}\r\n\t.st19{clip-path:url(#SVGID_00000001654711540831233290000011746038518091548345_);fill:#3C3C3B;}\r\n\t.st20{clip-path:url(#SVGID_00000054946873093016212550000006802192572241131949_);fill:#3C3C3B;}\r\n\t.st21{clip-path:url(#SVGID_00000031897059018095443320000008376672588055086263_);fill:#3C3C3B;}\r\n\t.st22{clip-path:url(#SVGID_00000013893007793245068690000005112968899041411768_);fill:#3C3C3B;}\r\n\t.st23{clip-path:url(#SVGID_00000076569147405272005220000008997008075827830917_);fill:#3C3C3B;}\r\n\t.st24{clip-path:url(#SVGID_00000091696645831918535970000015891471105499485084_);fill:#3C3C3B;}\r\n\t.st25{clip-path:url(#SVGID_00000010279052082764574380000008811754095045408161_);fill:#3C3C3B;}\r\n\t.st26{clip-path:url(#SVGID_00000048482625067264374430000003175371559532672129_);fill:#3C3C3B;}\r\n\t.st27{clip-path:url(#SVGID_00000127736503969529181060000000349801323508239279_);}\r\n\t.st28{clip-path:url(#SVGID_00000140005276060789981110000007641602323607633068_);}\r\n\t.st29{clip-path:url(#SVGID_00000066503044979981253120000011044603358053560251_);}\r\n\t.st30{clip-path:url(#SVGID_00000005969446879013229710000003774426385842971070_);}\r\n\t.st31{clip-path:url(#SVGID_00000163795766799284197330000011585272250260981937_);}\r\n\t.st32{clip-path:url(#SVGID_00000083090160158235701930000002837936715973166723_);}\r\n\t.st33{clip-path:url(#SVGID_00000136403783169841465260000018269028764279047562_);}\r\n\t.st34{clip-path:url(#SVGID_00000136370514077767407700000009583774475479839649_);}\r\n\t.st35{clip-path:url(#SVGID_00000127761856947415589450000014810835898674455685_);}\r\n\t.st36{clip-path:url(#SVGID_00000129188338788063972340000008792862615091506077_);}\r\n\t.st37{clip-path:url(#SVGID_00000056395730637738099310000001418752297485538714_);}\r\n\t.st38{clip-path:url(#SVGID_00000021100928993370198960000014718145786135443894_);}\r\n\t.st39{clip-path:url(#SVGID_00000013873817888508809320000001128529748598743198_);}\r\n\t.st40{clip-path:url(#SVGID_00000157270713181690182810000001322442586199649461_);}\r\n\t.st41{clip-path:url(#SVGID_00000064329087991129993040000000390745313702143929_);}\r\n\t.st42{clip-path:url(#SVGID_00000131361781828147249680000009370024702739623096_);}\r\n\t.st43{clip-path:url(#SVGID_00000059991394929480374640000016827618995305545616_);}\r\n\t.st44{clip-path:url(#SVGID_00000082337343904638719170000015671807475416434606_);}\r\n\t.st45{clip-path:url(#SVGID_00000110453744049309575010000005706244380653336472_);}\r\n\t.st46{clip-path:url(#SVGID_00000116222319862946505180000013631523784247557297_);}\r\n\t.st47{clip-path:url(#SVGID_00000114761335028848865220000012517947452903172277_);}\r\n\t.st48{clip-path:url(#SVGID_00000158714060413220686890000015095595699153925804_);}\r\n\t.st49{clip-path:url(#SVGID_00000111176707395935543700000015971486148133088443_);}\r\n\t.st50{clip-path:url(#SVGID_00000067916894867340460910000007583813966483726778_);}\r\n\t.st51{clip-path:url(#SVGID_00000147929138166775697760000015211151905543367841_);}\r\n\t.st52{clip-path:url(#SVGID_00000001639637702398729410000012921553625944597163_);fill:#FFE50B;}\r\n\t.st53{clip-path:url(#SVGID_00000106828174307794381810000001003686489728074684_);}\r\n\t.st54{clip-path:url(#SVGID_00000028307770034559509160000016682363565243959681_);}\r\n\t.st55{clip-path:url(#SVGID_00000146501319824575298000000009108652091540331176_);}\r\n\t.st56{clip-path:url(#SVGID_00000139284370128422442050000000230716103584332673_);}\r\n\t.st57{clip-path:url(#SVGID_00000029768613101421486680000009308567994853234105_);}\r\n\t.st58{clip-path:url(#SVGID_00000153681761828646565790000007862466251249328264_);}\r\n\t.st59{clip-path:url(#SVGID_00000033345643839794057340000002697493412423461033_);}\r\n\t.st60{clip-path:url(#SVGID_00000168080052353228062170000014273033354566335154_);}\r\n\t.st61{clip-path:url(#SVGID_00000111911366389324555920000018073365463724572571_);fill:#FFE50B;}\r\n\t.st62{clip-path:url(#SVGID_00000050664771730738991770000007247339593252469951_);fill:#EB586A;}\r\n\t.st63{clip-path:url(#SVGID_00000170249822211756197730000010590399881792499355_);fill:#706F6F;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065052427041548075240000000862139408936152510_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000065052427041548075240000000862139408936152510_)",
      fill: "#3C3C3B"
    },
    d: "M204.9,51.8v-1.5h2.5 v2.1c0.3-0.5,1.2-2.4,4.3-2.4c1.2,0,4.8,0.4,4.8,4.5v8.9H214v-8.3c0-0.9-0.1-1.6-0.7-2.2c-0.6-0.6-1.5-0.9-2.4-0.9 c-1.8,0-3.5,1.3-3.5,3.9v7.5h-2.5L204.9,51.8L204.9,51.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000061467319526170389390000008360814095035630264_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101816997637931489150000009420361607842214063_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000061467319526170389390000008360814095035630264_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000101816997637931489150000009420361607842214063_)",
      fill: "#3C3C3B"
    },
    d: "M221.9,57.2 c-0.1,2.7,1.1,4.7,3.8,4.7c1.6,0,2.9-0.8,3.1-2.7h2.5c-0.1,0.7-0.2,1.7-1.1,2.7c-0.6,0.6-1.9,1.7-4.6,1.7c-4.2,0-6.2-2.5-6.2-6.7 c0-2.6,0.5-4.7,2.6-6.1c1.3-0.9,2.9-1,3.7-1c6,0,5.9,5.2,5.8,7.3L221.9,57.2L221.9,57.2z M229,55.5c0-1.2-0.2-3.9-3.3-3.9 c-1.6,0-3.6,1-3.7,3.9H229z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000098930255558989734310000011859145149884601497_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132803470929267415480000005251606195182174089_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098930255558989734310000011859145149884601497_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132803470929267415480000005251606195182174089_)",
      fill: "#3C3C3B"
    },
    d: "M233.2,50.2h2.4v-2.7 l2.5-0.8v3.5h3V52h-3v7.8c0,0.6,0,1.7,1.8,1.7c0.5,0,1-0.1,1.2-0.1v1.9c-0.5,0.1-1.2,0.2-2.1,0.2c-2.3,0-3.4-0.7-3.4-2.8V52h-2.4 V50.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000094590364223076137870000004764065690522435256_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130646667866562145000000007393368335321391286_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094590364223076137870000004764065690522435256_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000130646667866562145000000007393368335321391286_)",
      fill: "#3C3C3B"
    },
    points: "242.8,60.8  250,52.1 243.2,52.1 243.2,50.3 252.8,50.3 252.8,52.3 245.4,61.4 252.8,61.4 252.8,63.3 242.8,63.3  "
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000018201670246747657450000017757190479008466322_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170969930757708516640000007579627612786357429_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018201670246747657450000017757190479008466322_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000170969930757708516640000007579627612786357429_)",
      fill: "#3C3C3B"
    },
    points: "256.9,50.3  260.1,60.7 263.5,50.3 266.8,50.3 269.8,60.6 273.2,50.3 275.8,50.3 271.1,63.3 268.2,63.3 265,52.6 261.6,63.3 258.6,63.3  254.2,50.3  "
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000080894157991518301770000015223322768734431667_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057858361601910009140000007663542781569328804_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080894157991518301770000015223322768734431667_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000057858361601910009140000007663542781569328804_)",
      fill: "#3C3C3B"
    },
    d: "M279.9,57.2 c-0.1,2.7,1.1,4.7,3.8,4.7c1.6,0,2.9-0.8,3.1-2.7h2.5c-0.1,0.7-0.2,1.7-1.1,2.7c-0.6,0.6-1.9,1.7-4.6,1.7c-4.2,0-6.2-2.5-6.2-6.7 c0-2.6,0.5-4.7,2.6-6.1c1.3-0.9,2.9-1,3.7-1c6,0,5.9,5.2,5.8,7.3L279.9,57.2L279.9,57.2z M287,55.5c0-1.2-0.2-3.9-3.3-3.9 c-1.6,0-3.6,1-3.7,3.9H287z"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000013882673614630956010000008970486972406748318_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176761354832626242650000002476620944996600996_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013882673614630956010000008970486972406748318_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000176761354832626242650000002476620944996600996_)",
      fill: "#3C3C3B"
    },
    d: "M293.3,52.9 c0-0.9-0.1-1.8-0.1-2.7h2.5l0.1,2.5c0.5-1.8,2.1-2.4,3.2-2.6c0.8-0.1,1.3-0.1,1.7-0.1v2.4c-0.1-0.1-0.3-0.1-0.5-0.1s-0.4,0-0.7,0 c-3,0-3.6,1.7-3.6,4v7h-2.5V52.9H293.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000118372337141489149200000007664188990648149914_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047028564764881604220000005888706372070125239_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118372337141489149200000007664188990648149914_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000047028564764881604220000005888706372070125239_)",
      fill: "#3C3C3B"
    },
    points: "303.4,44.4  305.9,44.4 305.9,55.6 310.9,50.3 314.2,50.3 308.5,55.8 314.5,63.3 311.2,63.3 305.9,56.3 305.9,63.3 303.4,63.3  "
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000111170831925007465010000002335925069013536438_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139972498315548534460000009929508000836504996_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111170831925007465010000002335925069013536438_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000139972498315548534460000009929508000836504996_)",
      fill: "#3C3C3B"
    },
    d: "M207.1,82.8v8.4 c0,1.3,0.3,2.9,2.8,2.9c1.3,0,2.4-0.4,3.1-1.5c0.6-0.8,0.6-1.8,0.6-2.4v-7.4h2.6v10.6c0,0.3,0.1,1.7,0.1,2.4h-2.6l-0.1-2.2 c-0.5,0.9-1.4,2.4-4.3,2.4c-3.3,0-4.8-1.8-4.8-4.4v-8.8H207.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000180337463917507768830000015135708812547619746_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180369034649679414100000009110343472470772659_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180337463917507768830000015135708812547619746_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000180369034649679414100000009110343472470772659_)",
      fill: "#3C3C3B"
    },
    d: "M221.2,84.3v-1.5h2.5 v2.1c0.3-0.5,1.2-2.4,4.3-2.4c1.2,0,4.8,0.4,4.8,4.5v8.9h-2.6v-8.3c0-0.9-0.1-1.6-0.7-2.2c-0.6-0.6-1.5-0.9-2.4-0.9 c-1.8,0-3.5,1.3-3.5,3.9v7.5h-2.5L221.2,84.3L221.2,84.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000056399365127183611290000009648914476863036597_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123407202168563884060000014709810177736794763_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056399365127183611290000009648914476863036597_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000123407202168563884060000014709810177736794763_)",
      fill: "#3C3C3B"
    },
    d: "M236.9,77.1h3v2.7h-3 V77.1z M237.1,82.8h2.5v13.1h-2.5V82.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000140695800770568958970000008953779414957954716_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146469030582732315500000016868712673264316298_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140695800770568958970000008953779414957954716_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000146469030582732315500000016868712673264316298_)",
      fill: "#3C3C3B"
    },
    points: "243,82.8  245.8,82.8 250.1,93.2 254.2,82.8 257,82.8 251.1,95.9 248.6,95.9  "
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000020391494431397926150000017168485953554653065_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015331117304456544020000004608089406845204923_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020391494431397926150000017168485953554653065_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000015331117304456544020000004608089406845204923_)",
      fill: "#3C3C3B"
    },
    d: "M261.4,89.8 c-0.1,2.7,1.1,4.7,3.8,4.7c1.6,0,2.9-0.8,3.1-2.7h2.5c-0.1,0.7-0.2,1.7-1.1,2.7c-0.6,0.6-1.9,1.7-4.6,1.7c-4.2,0-6.2-2.6-6.2-6.7 c0-2.6,0.5-4.7,2.6-6.1c1.3-0.9,2.9-1,3.6-1c6,0,5.9,5.2,5.8,7.3L261.4,89.8L261.4,89.8z M268.4,88.1c0-1.3-0.2-3.9-3.3-3.9 c-1.6,0-3.6,1-3.7,3.9H268.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000146495762158097883280000010246302824248929421_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015312514391864598240000011133674837481912766_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146495762158097883280000010246302824248929421_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000015312514391864598240000011133674837481912766_)",
      fill: "#3C3C3B"
    },
    d: "M274.8,85.5 c0-0.9-0.1-1.8-0.1-2.7h2.5l0.1,2.5c0.5-1.8,2.1-2.4,3.2-2.6c0.7-0.1,1.3-0.1,1.7-0.1V85c-0.1-0.1-0.3-0.1-0.5-0.1s-0.4,0-0.7,0 c-3,0-3.7,1.7-3.7,4v7h-2.5V85.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000137852110166215304370000001517859574029510307_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177477342060664386200000013214332313881695364_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137852110166215304370000001517859574029510307_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000177477342060664386200000013214332313881695364_)",
      fill: "#3C3C3B"
    },
    d: "M287,92 c0,1,0.5,2.4,2.9,2.4c1,0,1.8-0.2,2.3-0.8c0.3-0.3,0.4-0.8,0.4-1.2c0-1.3-0.9-1.5-2.9-2c-2.8-0.6-5.1-1.2-5.1-3.9 c0-2.4,2.1-4,5.2-4c1.7,0,4,0.5,4.8,2c0.3,0.7,0.3,1.4,0.3,1.9h-2.6c0.1-2-1.7-2.1-2.6-2.1c-0.4,0-2.7,0-2.7,1.9 c0,1.2,1.2,1.5,1.9,1.7c3.7,0.9,4.5,1.1,5.3,1.8c0.7,0.7,1,1.6,1,2.4c0,1.5-0.8,2.7-1.8,3.3c-1.2,0.7-2.6,0.9-4,0.9 c-2.7,0-5.3-1.1-5.2-4.2h2.8V92z"
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000108292044443396949310000006907251109440856463_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000012450718873779387650000001322907139781296036_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108292044443396949310000006907251109440856463_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000012450718873779387650000001322907139781296036_)",
      fill: "#3C3C3B"
    },
    d: "M298.6,77.1h3v2.7h-3 V77.1z M298.9,82.8h2.5v13.1h-2.5V82.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000121281937112379605950000006888498702224214445_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041984089199341821460000000910805671674093502_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121281937112379605950000006888498702224214445_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000041984089199341821460000000910805671674093502_)",
      fill: "#3C3C3B"
    },
    d: "M304.2,82.7h2.4V80 l2.5-0.8v3.5h3v1.8h-3v7.8c0,0.6,0,1.7,1.8,1.7c0.5,0,1-0.1,1.2-0.1v1.9c-0.5,0.1-1.2,0.2-2.1,0.2c-2.3,0-3.4-0.7-3.4-2.8v-8.7 h-2.4V82.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000172401636996310996280000005000062194291636380_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038389023164020408300000002456582750528212128_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172401636996310996280000005000062194291636380_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000038389023164020408300000002456582750528212128_)",
      fill: "#3C3C3B"
    },
    d: "M323.3,95.9 c-0.2-0.7-0.2-1.3-0.2-2c-1.2,2.2-3,2.4-4.1,2.4c-3.1,0-4.7-1.7-4.7-3.9c0-1,0.4-2.7,2.3-3.8c1.4-0.8,3.6-0.9,4.6-0.9 c0.6,0,1,0,1.8,0.1c0-1.6,0-2.3-0.5-2.9s-1.6-0.9-2.3-0.9c-2.5,0-2.7,1.7-2.7,2.2H315c0.1-0.7,0.2-1.6,0.9-2.5 c1-1.1,2.9-1.4,4.3-1.4c1.9,0,4,0.6,4.7,1.9c0.4,0.8,0.5,1.4,0.5,2l-0.1,6.2c0,0.2,0,2,0.2,3.3h-2.2V95.9z M316.4,77.1h2.4v2.7 h-2.4V77.1z M321.6,89.4c-1,0-4.8,0-4.8,2.7c0,0.8,0.5,2.3,2.8,2.3c1.3,0,2.2-0.5,2.8-1.4c0.6-0.9,0.6-1.6,0.6-3.4 C322.6,89.5,322.2,89.4,321.6,89.4 M321.5,77.1h2.5v2.7h-2.5V77.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000017517979180624967760000015813764318598234512_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006684789446212126710000000570402121444383410_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000017517979180624967760000015813764318598234512_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000006684789446212126710000000570402121444383410_)",
      fill: "#3C3C3B"
    },
    d: "M327.9,82.7h2.4V80 l2.5-0.8v3.5h3v1.8h-3v7.8c0,0.6,0,1.7,1.8,1.7c0.5,0,1-0.1,1.2-0.1v1.9c-0.5,0.1-1.2,0.2-2.1,0.2c-2.3,0-3.4-0.7-3.4-2.8v-8.7 h-2.4V82.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000180334423050377159490000013668905348430672012_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113346030526894571520000001778527320592897158_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180334423050377159490000013668905348430672012_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000113346030526894571520000001778527320592897158_)",
      fill: "#3C3C3B"
    },
    d: "M340.3,92 c0,1,0.5,2.4,2.9,2.4c1,0,1.8-0.2,2.3-0.8c0.3-0.3,0.4-0.8,0.4-1.2c0-1.3-0.9-1.5-2.9-2c-2.8-0.6-5.1-1.2-5.1-3.9 c0-2.4,2.1-4,5.2-4c1.7,0,4,0.5,4.8,2c0.3,0.7,0.3,1.4,0.3,1.9h-2.6c0.1-2-1.7-2.1-2.6-2.1c-0.4,0-2.7,0-2.7,1.9 c0,1.2,1.2,1.5,1.9,1.7c3.7,0.9,4.5,1.1,5.3,1.8c0.7,0.7,1,1.6,1,2.4c0,1.5-0.8,2.7-1.8,3.3c-1.2,0.7-2.6,0.9-4,0.9 c-2.7,0-5.3-1.1-5.2-4.2h2.8V92z"
  })), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000008132940527213035430000008997911003109266080_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013892921179543028350000017265427748261843350_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008132940527213035430000008997911003109266080_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000013892921179543028350000017265427748261843350_)",
      fill: "#3C3C3B"
    },
    d: "M204.3,117.7 c0-0.8-0.1-1.6-0.1-2.5h3.8l0.1,1.7c0.4-0.6,1.5-2,4.2-2c3.1,0,4,1.9,4.2,2.5c1.1-2.1,2.9-2.4,4.3-2.4c2.7,0,3.8,1.6,4.1,2.1 c0.7,1.1,0.7,2.7,0.7,3.9v7.4h-4v-7.7c0-1.4-0.2-3-2.3-3c-2.4,0-2.4,2.2-2.4,4.1v6.6h-4v-7.8c0-1,0-2.9-2.2-2.9 c-2.5,0-2.5,2.1-2.5,3v7.7h-4L204.3,117.7L204.3,117.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000009556084990601959760000014679530479311491261_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126325823686769618330000007085878780004018877_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009556084990601959760000014679530479311491261_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000126325823686769618330000007085878780004018877_)",
      fill: "#3C3C3B"
    },
    d: "M231.8,122.8 c0,0.9,0,3.5,2.7,3.5c1,0,2-0.4,2.3-1.8h3.6c-0.1,0.6-0.2,1.7-1.3,2.9c-1,1-2.7,1.5-4.7,1.5c-1.1,0-3.3-0.2-4.7-1.6 c-1.2-1.3-1.7-3-1.7-5.1s0.5-4.7,2.8-6.2c1-0.7,2.3-1.1,3.8-1.1c1.9,0,4.2,0.7,5.4,3.2c0.9,1.8,0.9,3.7,0.8,4.8L231.8,122.8 L231.8,122.8z M236.9,120.4c0-0.6-0.1-2.9-2.3-2.9c-1.7,0-2.4,1.4-2.5,2.9H236.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000017514237381770427560000014793825641945357190_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013892529503401087320000013312320153201665177_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000017514237381770427560000014793825641945357190_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000013892529503401087320000013312320153201665177_)",
      fill: "#3C3C3B"
    },
    d: "M252.4,109.6h4v16.7 c0,0.8,0.1,1.6,0.1,2.1h-4l-0.1-1.9c-0.3,0.5-0.5,1-1.4,1.5c-1,0.6-2,0.7-2.6,0.7c-3.6,0-5.7-2.4-5.7-6.5c0-4.3,2.4-7.1,5.9-7.1 c2.4,0,3.4,1.3,3.8,1.8V109.6z M249.4,126.2c1.1,0,2.1-0.7,2.5-1.5c0.6-1.1,0.6-2.4,0.6-3.1c0-2.6-1.2-4-2.9-4 c-2.6,0-2.9,3.1-2.9,4.4C246.7,124.2,247.4,126.2,249.4,126.2"
  })), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000058587561860115300250000003308766447075444662_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135657995765802293480000003057809658215463077_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058587561860115300250000003308766447075444662_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000135657995765802293480000003057809658215463077_)",
      fill: "#3C3C3B"
    },
    d: "M259.6,109.6h4.2v3.4 h-4.2V109.6z M259.8,115.2h3.9v13.2h-3.9V115.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000129193435817282563040000017421155861214591377_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097501766270800722780000018062547976158834867_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129193435817282563040000017421155861214591377_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000097501766270800722780000018062547976158834867_)",
      fill: "#3C3C3B"
    },
    points: "266.3,125  273.1,117.8 266.5,117.8 266.5,115.2 277.5,115.2 277.5,118.6 270.7,125.7 277.8,125.7 277.8,128.4 266.3,128.4  "
  })), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000129178961648622871660000003951413444955239871_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093878074315447442820000012926614506517703097_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129178961648622871660000003951413444955239871_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000093878074315447442820000012926614506517703097_)",
      fill: "#3C3C3B"
    },
    d: "M280.4,109.6h4.2v3.4 h-4.2V109.6z M280.5,115.2h3.9v13.2h-3.9V115.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000056401246170282208100000002358112929113026202_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041255723609935832390000015809924245223076275_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056401246170282208100000002358112929113026202_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000041255723609935832390000015809924245223076275_)",
      fill: "#3C3C3B"
    },
    d: "M288,117.6 c0-0.1,0-1.5-0.1-2.4h3.8l0.1,2c0.4-0.6,1.4-2.3,4.4-2.3c2.6,0,3.8,1.6,4.1,2.5c0.3,0.8,0.4,1.5,0.4,3.9v7.1h-4v-8.2 c0-0.5,0-1-0.2-1.4c-0.3-0.6-0.9-1.1-1.9-1.1c-0.9,0-1.6,0.4-2.1,1c-0.2,0.3-0.5,1-0.5,2v7.7h-4L288,117.6L288,117.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000060005280138304319720000003486023902310326674_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092435880836234598850000017237822457920453791_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060005280138304319720000003486023902310326674_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000092435880836234598850000017237822457920453791_)"
    },
    points: "78,71 77.9,71.2 78.1,71.2  "
  })), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000098908641858180066820000016330861600214179211_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131349875260769188050000001167932231040558007_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098908641858180066820000016330861600214179211_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000131349875260769188050000001167932231040558007_)"
    },
    points: "153.5,71.2 187.5,71.2  187.5,69.9 153.1,69.9 152.6,70.4  "
  })), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000039845835878665675420000012372149363301994633_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168085820555282106800000004450152282080617866_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039845835878665675420000012372149363301994633_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000168085820555282106800000004450152282080617866_)"
    },
    points: "114.4,69.9 79.2,69.9  78.9,70.2 79.9,71.2 114.4,71.2  "
  })), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000004537606958730681200000002572101632083068041_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095296369148583419210000013235838211273180330_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000004537606958730681200000002572101632083068041_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000095296369148583419210000013235838211273180330_)"
    },
    points: "76.9,69.9 39.3,69.9  39.3,71.2 76.1,71.2 77.1,70.2  "
  })), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000046299389354932645910000009905398930095727010_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062913736003479641740000005386977729096611504_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046299389354932645910000009905398930095727010_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 188.7,
    y: 69.9,
    style: {
      clipPath: "url(#SVGID_00000062913736003479641740000005386977729096611504_)"
    },
    width: 14.3,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000085950116704411492970000015754520839262653071_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039106255683215369430000017142195134509659574_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085950116704411492970000015754520839262653071_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000039106255683215369430000017142195134509659574_)"
    },
    points: "152.2,106.6 186.9,106.6  187.4,106.1 186.7,105.3 152.2,105.3  "
  })), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000067942654905523783560000008822327313650933659_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142151729647029087900000015290122500820725416_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067942654905523783560000008822327313650933659_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000142151729647029087900000015290122500820725416_)"
    },
    points: "42.9,105.3 41.7,106.6  79.1,106.6 79.1,105.3  "
  })), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000041276416041708735260000001663274621208468370_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149366612664620818170000012257371381092773537_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041276416041708735260000001663274621208468370_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000149366612664620818170000012257371381092773537_)"
    },
    points: "150.9,105.3 116.9,105.3  115.9,106.3 116.2,106.6 150.9,106.6  "
  })), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000134937641776653833650000017882283083517335479_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063625415189653447780000008838088864642744471_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134937641776653833650000017882283083517335479_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000063625415189653447780000008838088864642744471_)"
    },
    points: "188.8,105.6 188.7,105.7  188.7,106 189,106.3 188.7,106.5 188.7,106.6 201.7,106.6 201.7,105.3 188.7,105.3 188.7,105.6  "
  })), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000091704373826661252550000014844439931097682862_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028291365147519101330000012551855450679593860_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091704373826661252550000014844439931097682862_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000028291365147519101330000012551855450679593860_)"
    },
    points: "2.8,105.3 2.8,106.6  39.9,106.6 41.1,105.3  "
  })), /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000060725123004368630080000000395718888316924290_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091714590735175667000000017707429194425765549_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060725123004368630080000000395718888316924290_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000091714590735175667000000017707429194425765549_)"
    },
    points: "307.8,141 188.7,141  188.7,141.6 187.5,141.6 187.5,141 153.4,141 152.4,142 152.7,142.2 307.8,142.2  "
  })), /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000062871855542096096600000010267840885265784962_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165955383966910083030000004420616920633322422_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062871855542096096600000010267840885265784962_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000165955383966910083030000004420616920633322422_)"
    },
    points: "39.8,141 39.8,142.2  77.3,142.2 78.6,141  "
  })), /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000003800325881370958680000009855923107741129351_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052086173083013439080000010116377272571221431_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003800325881370958680000009855923107741129351_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000052086173083013439080000010116377272571221431_)"
    },
    points: "80.3,141 79.1,142.2  114.4,142.2 114.4,141  "
  })), /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000105398635567461794640000003722190079781281684_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114038230506974615690000017743593459040282782_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105398635567461794640000003722190079781281684_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000114038230506974615690000017743593459040282782_)"
    },
    points: "77.9,71.2 78,71 77.1,70.2  76.1,71.2 41.1,105.3 39.9,106.6 2.8,142.7 3.7,143.6 41.7,106.6 42.9,105.3  "
  })), /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000101098728791958155860000010487084125314941832_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181052152463523229510000016413697041341132188_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101098728791958155860000010487084125314941832_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000181052152463523229510000016413697041341132188_)"
    },
    points: "123.6,26.5 122.7,25.6  115.7,32.5 115.7,34.3  "
  })), /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000154403567297609611860000005937109393592384409_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054226901056666486470000011798034695838983814_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000154403567297609611860000005937109393592384409_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000054226901056666486470000011798034695838983814_)"
    },
    points: "78.9,70.2 79.2,69.9  114.4,35.5 114.4,33.7 78,69.3  "
  })), /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000176759079194197534290000016571264738311854775_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152249312197560182370000013677753501939394208_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176759079194197534290000016571264738311854775_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000152249312197560182370000013677753501939394208_)"
    },
    points: "115.7,144.7 115.7,138.6  115.7,107.8 115,107.2 114.4,107.7 114.4,141 114.4,142.2 114.4,177.4 115.7,176.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000146457194412175605730000012269650730619346349_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168092570173373710660000009572570863807706752_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146457194412175605730000012269650730619346349_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000168092570173373710660000009572570863807706752_)"
    },
    points: "114.4,69.9 114.4,71.2  114.4,104.9 115,105.4 115.7,104.7 115.7,73.6 115.7,67.5 115.7,36 114.4,34.8 115.3,33.9 115.7,34.3 115.7,34.3 115.7,32.5  114.4,33.7 114.4,35.5  "
  })), /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000077302148990799878390000011057106661611643533_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053508468895391103770000006286367092936280456_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077302148990799878390000011057106661611643533_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000053508468895391103770000006286367092936280456_)"
    },
    points: "114.4,189.7 115.7,189.7  115.7,177.9 114.4,179.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000050657309356497021020000015991235696302043833_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011710767623777563150000007287234040234062485_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050657309356497021020000015991235696302043833_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011710767623777563150000007287234040234062485_)"
    },
    points: "152.2,69.1 152.2,34.8  150.9,34.8 150.9,68.7 151.8,69.5  "
  })), /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000004538463523845222310000008729593397184717459_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166649457338758035680000014616611715878780841_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000004538463523845222310000008729593397184717459_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000166649457338758035680000014616611715878780841_)"
    },
    points: "152.2,140.5 152.2,106.6  152.2,105.3 152.2,71.7 151.8,71.2 150.9,72 150.9,105.3 150.9,106.6 150.9,140.5 151.5,141.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000143593217120558018600000002918727780151306680_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120540101454153774930000009882952559085072022_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143593217120558018600000002918727780151306680_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000120540101454153774930000009882952559085072022_)"
    },
    points: "150.9,143.4 150.9,178.6  152.2,178.6 152.2,143.5 151.5,142.9  "
  })), /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000010293148910886789080000015052607743303769993_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103944948262945606090000001174560203188731799_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010293148910886789080000015052607743303769993_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000103944948262945606090000001174560203188731799_)"
    },
    points: "187.5,104.4 188.7,105.6  188.7,105.3 188.7,71.2 188.7,69.9 188.7,1.7 187.5,1.7 187.5,69.9 187.5,71.2  "
  })), /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000104681444296008432730000000948920246450327181_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075868606021629745660000007948940516653966003_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104681444296008432730000000948920246450327181_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000075868606021629745660000007948940516653966003_)"
    },
    points: "188.7,105.7 188.5,105.9  188.7,106  "
  })), /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000168088651289350398330000017629400384028231566_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034768671475422982760000016287472636477535164_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168088651289350398330000017629400384028231566_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000034768671475422982760000016287472636477535164_)"
    },
    points: "187.5,107.8 187.5,141  187.5,141.6 188.7,141.6 188.7,141 188.7,106.6 188.7,106.5  "
  })), /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000183246767293357589990000009170437179245043105_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127023734272324326320000002438634388563077255_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183246767293357589990000009170437179245043105_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000127023734272324326320000002438634388563077255_)",
      fill: "#FFE50B"
    },
    d: "M149,138.6L149,138.6 L149,138.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000034794690866670325560000014095068238106372516_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028289203958031822660000013211674706137516422_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034794690866670325560000014095068238106372516_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000028289203958031822660000013211674706137516422_)"
    },
    points: "188.7,106.5 189,106.3  188.7,106 188.5,105.9 187.9,106.5 187.4,106.1 186.9,106.6 152.2,140.5 151.5,141.1 152.4,142 153.4,141 187.5,107.8  "
  })), /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000117675672156612335470000010868431744668536458_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098914436768880958390000018038653298119212948_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117675672156612335470000010868431744668536458_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000098914436768880958390000018038653298119212948_)"
    },
    points: "115.7,176.1 114.4,177.4  103.3,188.2 104.2,189.1 114.4,179.1 115.7,177.9 150.9,143.4 151.5,142.9 150.6,142  "
  })), /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070801074945861960760000007091431003167472768_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146488529155570837300000005329800606666386076_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070801074945861960760000007091431003167472768_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000146488529155570837300000005329800606666386076_)"
    },
    points: "150.6,142 151.5,142.9  152.2,143.5 188.2,178.6 189.1,177.8 152.7,142.2 152.4,142 151.5,141.1 150.9,140.5 149,138.7 149,138.6 116.2,106.6  115.9,106.3 115,107.2 115.7,107.8  "
  })), /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116197786225885183810000009508172067130396335_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004508982593247741000000014305640160464782990_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116197786225885183810000009508172067130396335_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000004508982593247741000000014305640160464782990_)"
    },
    points: "114.1,106.3 115,105.4  114.4,104.9 79.9,71.2 78.9,70.2 78,69.3 40.2,32.4 39.3,33.3 76.9,69.9 77.1,70.2 78,71 78.1,71.2  "
  })), /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000071526269606994457170000005700980443170766722_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021094477842141519850000009067226393319532709_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071526269606994457170000005700980443170766722_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000021094477842141519850000009067226393319532709_)"
    },
    points: "152.6,70.4 153.1,69.9  178.9,44.7 178,43.8 152.2,69.1 151.8,69.5  "
  })), /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000134240961465144386520000004380627055136881054_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054983564484560336660000007262269654025615240_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134240961465144386520000004380627055136881054_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000054983564484560336660000007262269654025615240_)"
    },
    points: "78.6,141 77.3,142.2  29.6,188.8 30.5,189.7 79.1,142.2 80.3,141 114.4,107.7 115,107.2 115.9,106.3 116.9,105.3 150.9,72 151.8,71.2 150.9,70.4  "
  })), /*#__PURE__*/React.createElement("g", null, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119803485729058951410000003170230420573937046_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065042990509842155170000004459435357333484951_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119803485729058951410000003170230420573937046_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065042990509842155170000004459435357333484951_)"
    },
    points: "115.7,104.7 115,105.4  114.1,106.3  "
  })), /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000058552862510072676280000005599189589368384401_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177444863528047411980000013353253401718641053_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058552862510072676280000005599189589368384401_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000177444863528047411980000013353253401718641053_)"
    },
    points: "150.9,70.4 151.8,71.2  152.2,71.7 186.7,105.3 187.4,106.1 187.9,106.5 188.5,105.9 188.7,105.7 188.8,105.6 188.7,105.6 187.5,104.4 153.5,71.2  152.6,70.4 151.8,69.5 150.9,68.7 115.7,34.3 115.3,33.9 114.4,34.8 115.7,36  "
  })), /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000165918953608432307940000002568087132041924760_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034810422044372422470000016928105127413397382_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165918953608432307940000002568087132041924760_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000034810422044372422470000016928105127413397382_)",
      fill: "#FFE50B"
    },
    points: "115.7,144.7  147.8,144.7 150.6,142 147.2,138.6 115.7,138.6  "
  })), /*#__PURE__*/React.createElement("g", null, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000083785172883972790720000014612434517165513391_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004516425264714565580000015224088309172971136_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083785172883972790720000014612434517165513391_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000004516425264714565580000015224088309172971136_)",
      fill: "#EB586A"
    },
    points: "114.1,106.3  111.2,103.4 79.1,103.4 79.1,105.3 79.1,106.6 79.1,109.6 110.7,109.6  "
  })), /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000026885469128196391640000005911989944271689622_",
    x: -10.8,
    y: 1.7,
    width: 373,
    height: 223
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096761401539567340160000006915313397398971825_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026885469128196391640000005911989944271689622_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000096761401539567340160000006915313397398971825_)",
      fill: "#706F6F"
    },
    points: "147.9,67.5  115.7,67.5 115.7,73.6 147.5,73.6 150.9,70.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumLogo);
export default __webpack_public_path__ + "static/media/num-logo.e4a1761306d64000cff070b736ffa0bb.svg";
export { ForwardRef as ReactComponent };